import React from 'react';
import MyVisitsDashboard from '../personal-dashboard/my-visits/MyVisitsDashboard';
const SalesVisitsDashboard = () => {
  return <MyVisitsDashboard isFromManagerPage />;
};

SalesVisitsDashboard.propTypes = {};

export default SalesVisitsDashboard;
